export const desktopIconData = {
  fallback: require('./desktopIcons/fallback.png'),
  changeBG: require('./desktopIcons/changeBG.png'),
};

export const startMenuIconData = {
  fallback: require('./startMenuIcons/fallback.png'),
  linkedin: require('./startMenuIcons/linkedIn.png'),
  github: require('./startMenuIcons/github.png'),
};

export const projectImageData = {
  lorcana: require('./projectImages/lorcana.png'),
  lorcanaMap: require('./projectImages/lorcanaMap.png'),
};

export const projectIconData = {
  "What's that Glimmer": require('./projectIcons/lorcana.png'),
};
